import type { BuybackOrderDetailsCounterOfferReason } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher.types'

export type CounterOfferFormattedReasonsGroup = {
  reasons: {
    checked: boolean
    id: string
    label: string
  }[]
  id: string
  label: string
}

export const counterOfferReasonsGroupAdapter = ({
  groups = [],
  selected = [],
}: {
  groups: BuybackOrderDetailsCounterOfferReason[]
  selected?: string[]
}): CounterOfferFormattedReasonsGroup[] => {
  return groups.map((group) => {
    return {
      ...group,
      reasons: group.reasons.map((reason) => {
        return {
          ...reason,
          checked: (selected || []).includes(reason.id),
        }
      }),
    }
  })
}
